import RestCountries from "./../assets/portfolioImages/restcountries.png";
import Cini from "./../assets/portfolioImages/cini.png";
import Fillrouge from "./../assets/portfolioImages/fillrouge.png";


import Evinto from "./../assets/portfolioImages/evinto.png";
import landingPage from "./../assets/portfolioImages/url.jpg";
import archiplus from "./../assets/portfolioImages/archiplus.png";

const ProjectsData = [
  {
    id: "oneHand",
    img: Fillrouge,
    name: "One Hand",
    stack: ["< RESTful API />", "< Bootstrap v5 />", "< React.js />"],
    live: "oneHand",
    source: "https://github.com/alaeddinerami/FilRouge.git",
    description:
      "One Hand is a platform I built using PHP Laravel to assist international students. It enables users to easily book campus accommodations, order meals, and share documents. With One Hand, our mission is to make their lives easier and less stressful as they transition to a new city for their studies.",
  },
  {
    id: "fyp",
    img: Evinto,
    name: "événements sportifs",
    stack: ["< RESTful API />", "< Bootstrap v5 />", "< React.js />"],
    live: "",
    source: "https://github.com/alaeddinerami/evenements-sportifs.git",
    description:
      "Developed a sports event management system that allows organizers to manage events, handle participant registrations, and generate attendee lists. Built with Laravel (Blade), featuring authentication, validation, and robust error handling. The application is fully Dockerized for deployment."
  },
  {
    id: "rest-countries",
    img: RestCountries,
    name: "MEDCONNECT",
    stack: ["< RESTful API />", "< Bootstrap v5 />", "< React.js />"],
    live: "",
    source: "https://github.com/alaeddinerami/MEDCONNECT.git",
    description:
      "Developed MédiConnect, a Laravel-based platform for managing medical appointments. Patients can explore specialties, book same-day or emergency appointments, leave reviews, and access medical certificates. Doctors manage patient records and prescriptions via dashboards, while admins handle specialties and medications. Features include secure authentication, role-based access, and Docker-based deployment",
  },

  {
    id: "space-tourism",
    img: Cini,
    name: "CinéManager",
    stack: ["< React.js />", "< CSS3 />"],
    live: "",
    source: "https://github.com/alaeddinerami/cinemanger-project.git",
    description:
      "Developed a hybrid platform integrating cinema management with an online streaming service. Subscribers can stream movies, rate and comment on videos, filter by genre, and manage favorites via a personalized dashboard. Admins have full control through an ergonomic dashboard to manage users, upload videos, and view metrics.",
  },
  {
    id: "archiplus",
    img: archiplus,
    name: "ArchiPlus",
    stack: ["< Next.js />", "< prisma />"],
    live: "",
    source: "https://github.com/salvia-salvia/ArchiPlus",
    description:
      "Developed using Next.js, React, and Tailwind CSS, Archiplus is a modern web platform designed for managing architectural projects efficiently. The application features server-side rendering for optimized performance and SEO, dynamic routing for seamless navigation, and a modular component-based architecture. Integrated with a RESTful API, it enables real-time data management and collaboration. I contributed to building responsive UI components, implementing state management, and optimizing backend interactions for fast, scalable performance.",
  },



];

const InprogressProjectsData = [
  {
    id: "url-short",
    img: landingPage,
    name: "URL shortening API landing page",
    stack: ["< JavaScript />", "< NodeJS />"],
    live: "",
    source: "https://github.com/rimshub/URL-shortening-API-landing-page",
    description:
      "Integrate with the shrtcode URL shortening API and play with browser storage in this landing page challenge",
  },
];

export default { ProjectsData, InprogressProjectsData };
